import { Card } from '../components/Card';
import { useContent } from '../data/ContentContext';
import './pages.css';

interface InfoPageProps {
  slug: string;
}

export function InfoPage({ slug }: InfoPageProps) {
  const { infoPages } = useContent();
  const content = infoPages[slug];

  if (!content) {
    return (
      <div className="page">
        <Card title="Coming soon">
          <p>This section is not available yet.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="page">
      {slug === 'deep-research' && (
        <>
          <div
            className="info-banner"
            role="img"
            aria-label="Deep Research — in-depth, multi-step investigation across the SQM knowledge base"
          />

          <section className="dr-modules">
            <article className="dr-capsule dr-capsule--light">
              <div className="dr-capsule__text">
                <h2 className="dr-capsule__title">
                  SQM AI Inspection Lab
                  <span className="dr-capsule__accent">.</span>
                </h2>
                <p className="dr-capsule__desc">
                  Self-built AI inspection workflow that enables automated
                  feasibility assessment for visual inspection of various
                  cosmetic parts.
                </p>
                <button type="button" className="dr-capsule__btn">
                  See how it works
                </button>
              </div>
              <div className="dr-capsule__media">
                <img
                  src="/deep-research/intro-banner.png"
                  alt="Deep Research investigating the SQM knowledge base"
                  className="dr-capsule__img"
                />
              </div>
            </article>

            <article className="dr-capsule dr-capsule--reverse">
              <div className="dr-capsule__text">
                <h2 className="dr-capsule__title">
                  Mechanical SQM Material &amp; Tooling Research
                  <span className="dr-capsule__accent">.</span>
                </h2>
                <p className="dr-capsule__desc">
                  Research output from Mechanical SQM's materials and tooling
                  experts, applicable to Amazon hardware products.
                </p>
                <button type="button" className="dr-capsule__btn">
                  Explore the knowledge base
                </button>
              </div>
              <div className="dr-capsule__media">
                <img
                  src="/deep-research/intro-banner.png"
                  alt="Source-backed findings from the SQM knowledge base"
                  className="dr-capsule__img"
                />
              </div>
            </article>
          </section>
        </>
      )}

      {slug !== 'deep-research' && (
        <Card title={content.title} icon={content.icon}>
          <p>{content.intro}</p>
        </Card>
      )}

      {slug !== 'deep-research' && (
        <Card title="What you get" icon="✨">
          <ul className="page__list">
            {content.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
}
